import { Container } from '@cgs/wge';
import { IconsSoundModel } from '../../../reels_engine/icons_sound_model';
import { RESOURCES_COMPONENT_TOKEN } from '../../../type_definitions';
import { IconsSoundModelComponent } from '../icons_sound_model_component';
import { ResourcesComponent } from '../resources_component';
import { FreeFallIconsSoundModel } from './free_fall_icons_sound_model';

interface IFreeFallIconsSoundModelComponentParams {
  maxIconId?: number;
}

const DEFAULT_MAX_ICON_ID = 60;

export class FreeFallIconsSoundModelComponent implements IconsSoundModelComponent {
  public iconsSoundModel: IconsSoundModel;

  constructor(container: Container, params?: IFreeFallIconsSoundModelComponentParams) {
    console.log('load ' + this.constructor.name);
    const res = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);

    this.iconsSoundModel = new FreeFallIconsSoundModel(
      res.sounds,
      params?.maxIconId ?? DEFAULT_MAX_ICON_ID
    );
  }
}
